import { toMathRound } from './to-math-round.util';

export const formatDisplayValue = (
  value: null | number | undefined,
  {
    multiply = 1,
    prefix,
    suffix,
    roundTo = 2,
  }: { multiply?: number; prefix?: string; roundTo?: number; suffix?: string } = {},
) => {
  // `-` means "no data"; a real 0 (e.g. pre-money valuation of the first round) must render as 0.
  if (value === null || value === undefined) return '-';

  const displayValue = value * multiply;

  if (!Number.isFinite(displayValue)) return '-';

  return `${prefix || ''}${toMathRound(displayValue, roundTo).toLocaleString('en-US')}${suffix || ''}`;
};
